import { inject, Injectable } from '@angular/core';
import { APIRequestOptions, APIRequestResources, APIResponse, ApiService } from '../../../core';

@Injectable({
    providedIn: 'root'
})
export class InventoryItemService {
    private readonly apiService = inject(ApiService);

    getInventoryItems(params: {
        itemCode?: string;
        itemDesc?: string;
        category?: string;
        itemGroup?: number;
        availableGorBom?: number;
        availableForStock?: number;
        itemType?: number;
        department?: number;
        itemsPerPage?: number;
        pageNumber?: number;
    }) {
        const options: APIRequestOptions = {
            endpoint: '',
            params: {
                ...(params.itemCode && { itemCode: params.itemCode }),
                ...(params.itemDesc && { itemDesc: params.itemDesc }),
                ...(params.category && { category: params.category }),
                ...(params.itemGroup && { itemGroup: params.itemGroup }),
                ...(params.availableGorBom && { availableGorBom: params.availableGorBom }),
                ...(params.availableForStock && { availableForStock: params.availableForStock }),
                ...(params.itemType && { itemType: params.itemType }),
                ...(params.department && { department: params.department }),
                itemsPerPage: params.itemsPerPage ?? 20,
                pageNumber: params.pageNumber ?? 1
            }
        };

        return this.apiService.GET<any>(
            APIRequestResources.InventoryService,
            options
        );
    }

    searchByItemCode(itemCode: string, pageSize: number = 20, page: number = 1) {
        return this.getInventoryItems({
            itemCode,
            itemsPerPage: pageSize,
            pageNumber: page
        });
    }

    searchByDescription(itemDesc: string, pageSize: number = 20, page: number = 1) {
        return this.getInventoryItems({
            itemDesc,
            itemsPerPage: pageSize,
            pageNumber: page
        });
    }
}